import {PlayParticipantsContainerController} from "./PlayParticipantsContainer";

export class ParticipantsControlsController {
    public participants: any[];
    public league: any;
    public sorting: any;
    public filtering: PlayParticipantsContainerController;
    public app: any;

    /**
     * Set name filter.
     */
    public setNameFilter(substr) {
        this.app.filterByName(substr);
    }

    /**
     * Reset filters.
     */
    public resetFilters() {
        this.app.resetFilters();
    }
}